import { render, staticRenderFns } from "./custodia-historias-ver.vue?vue&type=template&id=2d03a15a&scoped=true&"
import script from "./custodia-historias-ver.vue?vue&type=script&lang=js&"
export * from "./custodia-historias-ver.vue?vue&type=script&lang=js&"
import style0 from "./custodia-historias-ver.vue?vue&type=style&index=0&id=2d03a15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03a15a",
  null
  
)

export default component.exports